import React from "react";

// Assets
import "~/assets/sass/pages/mypage/admin/license/fee.scss";
import { useTranslation } from "react-i18next";
import { ArrowSaleIcon } from "~/assets/svg/TeamInfoIcon";
import { DetailCompare } from "./component/DetailCompare";
import useAlert from "~/common/hooks/useAlert";
import { DateWithDayName, thousandFormatter } from "~/utils/formatter";
import { LICENSE_PERIOD } from "~/common/constants/form";

const compareList = [
	{ free: true, enterprise: true, name: "VC 정보" },
	{ free: true, enterprise: true, name: "포트폴리오" },
	{
		free: true,
		enterprise: true,
		name: "투자 기업 검색",
	},
	{
		free: true,
		enterprise: true,
		name: "투자 심사",
		tooltip: "깃발 ST에 등록된 기업에게 온라인 투자 심사를 요청할 수 있습니다.",
	},
	{
		free: false,
		enterprise: true,
		name: "라운드 심사",
		tooltip:
			"직접 라운드 등록 후 내부/외부 심사역과 심사항목 설정 후 기업의 투자 심사를 진행할 수 있습니다.",
	},
	{
		free: false,
		enterprise: true,
		name: "라운드 등록",
	},
	{
		free: true,
		enterprise: true,
		name: "Apply 심사",
		tooltip: "링크를 통해 기업의 정보와 자료를 수집하고 투자 심사를 진행할 수 있습니다.",
	},
	{
		free: true,
		enterprise: true,
		name: "Apply 신청 양식 생성",
		tooltip: "직접 Apply 신청 양식을 생성해 기업의 필요한 정보만 수집할 수 있습니다.",
	},
	{
		free: false,
		enterprise: false,
		name: "투자 관계망(준비중)",
	},
];

const FeePage = ({
	purchaseInfo,
	handleApplyButton,
	showApplyAlert,
	ApplyAlert,
	UnsubscriptionAlert,
	showUnsubscriptionAlert,
	unsubscriptionRequest,
	showExpiredLicenseAlert,
	ExpiredLicenseAlert,
}) => {
	const { t } = useTranslation();
	const isPromotion = purchaseInfo.promotion ?? true;

	const [showAlert, InfoAlert] = useAlert();

	const unsubscriptionLicense = () => {
		if (purchaseInfo.deactivatedDate) {
			showExpiredLicenseAlert();
		} else {
			showUnsubscriptionAlert().then(() => unsubscriptionRequest.call());
		}
	};

	const renderButton = {
		free() {
			return purchaseInfo.licenseStatus === this.free.name ? (
				<button type="button" className="btn__solid" color="primary">
					이용중
				</button>
			) : (
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() =>
						purchaseInfo.members > 6
							? showAlert()
							: purchaseInfo.deactivatedDate
							? showApplyAlert()
							: handleApplyButton(this.free.name)
					}
				>
					적용하기
				</button>
			);
		},
		enterprise() {
			return purchaseInfo.licenseStatus === this.enterprise.name ? (
				<button type="button" className="btn__solid" color="primary">
					이용중
				</button>
			) : (
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => handleApplyButton(this.enterprise.name)}
				>
					적용하기
				</button>
			);
		},
		ultimate() {
			return purchaseInfo.licenseStatus === this.ultimate.name ? (
				<button type="button" className="btn__solid" color="primary">
					이용중
				</button>
			) : (
				<button type="button" className="btn__solid" color="primary" disabled>
					적용하기
				</button>
			);
		},
	};

	return (
		<>
			<div className="c__card payment-guide-wrap">
				<div className="payment-title">요금안내</div>
				<div className="payment-option">
					<div
						className={`c__card free ${
							purchaseInfo.licenseStatus === "free" && "active"
						}`}
					>
						<div className="card-title">
							<h4 className="payment-type">Free</h4>
							<p className="payment-limit">팀원 5명 이하</p>
							<div className="payment-price">멤버당/월</div>
						</div>
						<div className="payment-intro">
							<span className="payment-intro-text">무료</span>
						</div>
						<p className="payment-desc">
							국내 투자 유망 기업을 찾고 있다면? <br />
							발굴부터 심사까지 한곳에서 끝내세요.
						</p>
						{renderButton["free"]()}
					</div>
					<div
						className={`c__card enterprise ${
							purchaseInfo.licenseStatus === "enterprise" && "active"
						}`}
					>
						<div className="card-title">
							<h4 className="payment-type">Enterprise</h4>
							<p className="payment-limit">팀명 6명 ~ 50명</p>
							<div className="payment-price">멤버당/월</div>
						</div>
						<div className="payment-intro">
							{isPromotion ? (
								<>
									<div className="discount-wrap">
										{`${thousandFormatter(LICENSE_PERIOD["month"].money)}원`}
										<ArrowSaleIcon />
									</div>
									<span className="payment-intro-text">무료</span>
									<p className="payment-intro-desc">
										Enterprise 1년 무료사용 이벤트!
									</p>
								</>
							) : (
								<span className="payment-intro-text">
									{`${thousandFormatter(LICENSE_PERIOD["month"].money)}원`}
								</span>
							)}
						</div>
						<p className="payment-desc">
							투자 이벤트 등록시 심사역 배정,
							<br />
							심사항목설정, 결과 통보까지 투자의 전 과정을
							<br />
							직접 진행 할 수 있어요.
						</p>
						{renderButton["enterprise"]()}
					</div>
					<div className={`c__card ultimate`}>
						<div className="card-title">
							<h4 className="payment-type">Ultimate</h4>
							<p className="payment-limit">팀원 협의</p>
							<div className="payment-price">멤버당/월</div>
						</div>
						<div className="payment-intro">
							<span className="payment-intro-text">협의</span>
						</div>
						<p className="payment-desc">
							깃발 VC의 모든 플러그인과 투자 관계망
							<br />
							서비스까지 모두 이용할 수 있어요.
						</p>
						{renderButton["ultimate"]()}
					</div>
				</div>
				<div className="c__table payment-detail-table">
					<div className="thead">
						<div className="tr">
							<div className="th item-detail">라이센스별 상세비교</div>
							<div className="th item-free">Free</div>
							<div className="th item-enterprise">Enterprise</div>
							<div className="th item-ultimate">Ultimate</div>
						</div>
					</div>
					<div className="tbody">
						{compareList.map((item, index) => (
							<DetailCompare key={index} {...item} />
						))}
					</div>
				</div>
			</div>
			<ApplyAlert
				type="info"
				confirm={"확인"}
				width={480}
				height={306}
				message={
					<>
						<h3>이미 라이센스를 free로 변경하셨습니다.</h3>
						<p>
							{DateWithDayName(
								new Date(purchaseInfo.expDate).setDate(
									new Date(purchaseInfo.expDate).getDate() + 1
								)
							)}{" "}
							00시부터 free 라이센스로 깃발 서비스를 이용하실 수 있습니다.
						</p>
					</>
				}
			/>
			<InfoAlert
				type="info"
				confirm={"확인"}
				width={430}
				height={306}
				message={
					<>
						<h3>6명 이상의 팀원이 존재할 시 free 라이센스가 이용 불가능합니다.</h3>
						<p>팀원초대 메뉴에서 팀원 수를 확인해주세요.</p>
					</>
				}
			/>
			<UnsubscriptionAlert
				type="warning"
				confirm={"예"}
				reject={"아니요"}
				width={430}
				height={310}
				layout="horiz"
				message={
					<>
						<h3>구독을 취소하시겠습니까?</h3>
					</>
				}
				desc={
					<div className="desc-box error">
						{purchaseInfo.licenseStatus === "enterprise"
							? `현재 이용중인 enterprise 라이센스의 이용기간은 ${DateWithDayName(
									purchaseInfo.expDate
							  )} 까지 입니다.`
							: // 		`현재 이용중인 enterprise 라이센스의 이용기간은
							  // ${DateWithDayName(purchaseInfo.expDate)} 까지 입니다.`
							  "현재 이용중인 free 라이센스의 이용을 중지합니다."}
						<br />
						{`구독 취소를 하시면 ${DateWithDayName(
							new Date(purchaseInfo.expDate).setDate(
								new Date(purchaseInfo.expDate).getDate() + 1
							)
						)} 00시 부터 free 라이센스로 깃발 서비스를 이용하실 수 있습니다.`}
					</div>
				}
			/>
			<ExpiredLicenseAlert
				type="info"
				confirm={"확인"}
				width={500}
				message={
					<>
						<h3>이미 구독을 취소하셨습니다.</h3>
						<p>
							{DateWithDayName(
								new Date(purchaseInfo.expDate).setDate(
									new Date(purchaseInfo.expDate).getDate() + 1
								)
							)}{" "}
							00시 부터 free 라이센스로 깃발 서비스를 이용하실 수 있습니다.
						</p>
					</>
				}
			/>
		</>
	);
};

export default FeePage;
